import ModernLayout from '@/components/shared/ModernLayout';
import Layout from '@/components/template/Layout';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { useTreeCourses } from '@/data/context/TreeCoursesContext';
import useCourseTreeNavigate from '@/data/hook/course-line/useCourseTreeNavigate';
import {
  BreadcrumbItem,
  useDynamicBreadcrumbItems,
} from '@/data/hook/useDynamicBreadcrumbItems';
import { Breakpoints } from '@/utils/Breakpoint';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router-dom';
import NoAdminScreenForMobile from '../admin/NoAdminScreenForMobile';
import CourseFileTreeOrquester from '@/components/course-line/navigation/CourseFileTreeOrquester';

export default function CourseLineFormPage() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.layout',
  });
  const isDesktop = useMediaQuery({ minWidth: Breakpoints.lg });
  const { tree } = useTreeCourses();
  const { navigate } = useCourseTreeNavigate();
  const breadcrumbItems = useDynamicBreadcrumbItems(tree?.current.observer);

  const handleItemClick = (item: BreadcrumbItem) =>
    navigate(item.href ?? '', { treeKey: item.treeKey });

  return (
    <Layout>
      <ConditionalRenderer condition={!isDesktop}>
        <NoAdminScreenForMobile />
      </ConditionalRenderer>
      <ConditionalRenderer condition={isDesktop}>
        <ModernLayout
          items={breadcrumbItems}
          onBack={() => navigate(-1)}
          onItemClick={handleItemClick}
          backLabel={t('back')}
        >
          <CourseFileTreeOrquester />
          <Outlet />
        </ModernLayout>
      </ConditionalRenderer>
    </Layout>
  );
}
